<div *ngIf="exibir" class="load">
    <div class="modal-loader"></div>
    <div class="loader"></div>
</div>